import { colours } from "@shared/ui.design-system";

export const Message = {
  baseStyle: {
    fontSize: "0.9rem",
    borderRadius: "2px",
    borderLeft: "4px solid",
    position: "relative",
    h3: {
      ml: "-2rem",
      fontWeight: 700,
      pl: "2rem",
      position: "relative",
      _before: {
        position: "absolute",
        left: 0,
        fontWeight: "normal"
      }
    },
    p: "2rem",
    pl: "4rem",
    m: 0
  },
  variants: {
    error: {
      borderColor: colours.error.medium,
      background: colours.error.light,
      h3: { _before: { content: "'⚠'", fontSize: "1.3em" } }
    },
    info: {
      borderColor: colours.primary.dark,
      background: colours.secondary.soft,
      h3: { _before: { content: "'ⓘ'", fontSize: "1.2em" } }
    },
    confirmation: {
      borderColor: colours.success.medium,
      background: colours.success.light,
      h3: { _before: { content: "'✓'" } }
    },
    warning: {
      borderColor: colours.warning.medium,
      background: colours.warning.light,
      h3: { _before: { content: "'⚠'", fontSize: "1.3em" } }
    }
  },
  defaultProps: {
    variant: "info"
  }
};
